module.exports = __webpack_public_path__ + "img/job-heavy.1cb22929.svg";